export default __webpack_public_path__ + "static/headshot-ed60ecfe5fa6069e3231fa63cc854a66.jpeg";